//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "DOWNE_score_for_neonatal_respiration",
  data() {
    return {
      form: {
        limb: "",
        breath: "",
        loop: "",
        state: "",
        bloodOxygen: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "＜60次/min" },
        { value: "1", name: "≥60~＜80次/min" },
        { value: "2", name: "≥80次/min" },
      ],
      dataList2: [
        { value: "0", name: "无青紫" },
        { value: "1", name: "吸入空气时有青紫" },
        { value: "2", name: "吸入氧浓度40%时有青紫" },
      ],
      dataList3: [
        { value: "0", name: "三凹征" },
        { value: "1", name: "轻度" },
        { value: "2", name: "中度或重度" },
      ],
      dataList4: [
        { value: "0", name: "无" },
        { value: "1", name: "轻度" },
        { value: "2", name: "中度或重度" },
      ],
      dataList5: [
        { value: "0", name: "清晰" },
        { value: "1", name: "减低" },
        { value: "2", name: "微弱或听不到" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Pedi/DOWNE_score_for_neonatal_respiration.vue